import { Navigate } from "react-router-dom"
import { companyEnergyAuditRoutes } from "@/pages/dashboard/company-energy-audit/routes.tsx"
import { controlRoutes } from "@/pages/dashboard/control/routes.tsx"
import { dashboardPageRoutes } from "@/pages/dashboard/dashboard-page/routes.tsx"
import { auditorEnergyAuditRoutes } from "@/pages/dashboard/energy-audit/routes.tsx"
import { inspectionEnergyAuditRoutes } from "@/pages/dashboard/inspection-energy-audit/routes.tsx"
import { otmRoutes } from "@/pages/dashboard/otm-page/routes.tsx"
import { rootRoutes } from "@/pages/dashboard/root/routes.tsx"
import type { CustomRoute } from "@/shared/types"
import { administrationRoutes } from "./administration/routes"
import { auditorPortfolioRoutes } from "./auditor-portfolio/routes"

const dashboardRoutes: CustomRoute[] = [
  {
    element: <Navigate to="root" />
  },
  rootRoutes,
  dashboardPageRoutes,
  administrationRoutes,
  otmRoutes,
  // mapRoutes,
  controlRoutes,
  companyEnergyAuditRoutes,
  auditorEnergyAuditRoutes,
  auditorPortfolioRoutes,
  inspectionEnergyAuditRoutes
  // energyPassportRoutes,
  // energyIntensityRoutes,
]

export default dashboardRoutes
